import React, { useContext, useEffect, useState } from 'react';
import Select from "react-select";
import { Icon } from '@iconify/react';
import { addcontext } from '../../ContextShare/ContextShare';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { ToastContainer, toast } from 'react-toastify'
import { AddGovAddresApi, AddRulingsApi, getCurrentSpeaker, getDomainName, GetEventListForSearchFilter, GetKlaListForSearchFilter, GetMemberListForSearchFilterIfSession, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla, getSittingDates } from '../../Services/allApi';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import InfoIcon from '../../Components/InfoIcon'

// Custom option component
const CustomOption = (props) => {
    const { innerRef, innerProps, data } = props;
    const parts = data.label.split(',');
    const constituency = parts[0];
    const reservedFor = parts[1];
    // const reservedForMalayalam = parts[2]
  
    return (
      <div ref={innerRef} {...innerProps} className="custom-option">
        <div className="flex flex-row gap-2 w-full border border-blue-gray-300 bg-gray-100 mb-2 hover:bg-gray-300 cursor-pointer ">
          <div className="w-6/12 flex-1 flex p-1 border-r border-gray-300">{constituency}</div>
          {/* <div className=" p-1 border-r border-gray-300 w-6 ">{reservedFor}</div> */}
          <div className=" p-1 items-start justify-start flex flex-col w-5/12  ">{reservedFor}</div>
        </div>
      </div>
    );
  };
  
  // Custom styles for the select component
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
    }),
    menu: (provided) => ({
      ...provided,
      width: '500px',
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '5px 10px',
    }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
        height: '2rem',
        borderRadius: '0.5rem',
    }),
  };
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
function AddRulings() {
    // const [stepFourCompleted,setstepFourCompleted]=useState(false)
    const { initalDateVideoAddPage, setinitalDateVideoAddPage } = useContext(addcontext)
    const { addrulings,setaddrulings } = useContext(addcontext)
    const [currentStep, setCurrentStep] = useState(1);
    const [completedSteps, setCompletedSteps] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [videoDetailsArray, setVideoDetailsArray] = useState([]);
    const { addVideo, setAddVideo } = useContext(addcontext)
    const [sessionList, setSessionList] = useState([])
    const [eventList, setEventList] = useState([])
    const [items, setItems] = useState(['com1', 'com2', 'com3', 'com4']);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [klaList, setKlaList] = useState([])
    const [memberList, setMemberList] = useState([])
    const [errorMsg, setErrorMsg] = useState()
    const [domainOptions, setDomainOptions] = useState([]);
    const [VideoInitialDetails, setVideoInitialDetails] = useState({
        video_upload_date: '',
        kla: null,
        video_session: null,
        numberOfVideos: '',
        domain_name:'',
        file_path:localStorage?.getItem("filePath")??''
    });
    const [fixedEvent,setFixedEvent]=useState({label:'',id:''})

    const handleDragStart = (event, index) => {
        event.dataTransfer.setData("text/plain", index);
        setDraggedIndex(index);
        toast.info("started dragging")
    };
    const navigate=useNavigate()

    const handleDragOver = (event, index) => {
        event.preventDefault();
    };
  // get domain name
  const getDomain=async()=>{
    const token = sessionStorage.getItem('access_token')
    const reqHeader = {
        "Content-Type": "application/json",
        "Authorization": `${token}`
    };
    const result=await getDomainName(reqHeader)

    const options = result?.data?.data?.map((item) => ({
        value: item?.id,
        label: item?.domain_name,
        valueApi: item.id,
      }));
      setDomainOptions(options);

        const latestDomain = (options ?? []).reverse()
        console.log('latest',latestDomain[0]?.domain_name);
        
        setVideoInitialDetails(prevState => ({
            ...prevState,
            domain_name: latestDomain[0]
        }));
    // setVideoInitialDetails({ ...VideoInitialDetails, domain_name: result?.data?.data[0]?.domain_name });
    // console.log(result);
    // setDomainName(result?.data?.data[0]?.domain_name)
}

useEffect(()=>{
    getDomain()
},[])
    const handleDrop = (event, index) => {
        event.preventDefault();
        const droppedIndex = parseInt(event.dataTransfer.getData("text/plain"));
        if (droppedIndex !== index) {
            const newItems = [...videoDetailsArray];
            const draggedItem = newItems[draggedIndex];
            newItems.splice(draggedIndex, 1);
            newItems.splice(index, 0, draggedItem);
            setVideoDetailsArray(newItems);
            toast.success("Dragged successfully")
        }
    };

    const formatDateToString = (date) => {
        if (!date) return '';
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    useEffect(() => {
        const date = initalDateVideoAddPage ? new Date(initalDateVideoAddPage) : new Date();
        setVideoInitialDetails(prev => ({ ...prev, video_upload_date: formatDateToString(date) }));
    }, [initalDateVideoAddPage]);

    const handleDateChange = (date) => {
        setVideoInitialDetails({ ...VideoInitialDetails, video_upload_date: formatDateToString(date) });
    };

    const parseDate = (dateString) => {
        if (!dateString) return null;
        const [year, month, day] = dateString.split('-');
        return new Date(year, month - 1, day);
    };


    const validateStepCompletion = (step) => {
        if (step === 1) {
            // return VideoInitialDetails.kla && VideoInitialDetails.video_session && VideoInitialDetails.video_upload_date;
            return true;
        }
        else if (step === 2) {
            return true
        }
        else if (step === 3) {
            return true
        }
        return true;
    };

    const handleNextStep = (step) => {
        if (step < currentStep) {
            setCurrentStep(step)
        }
        else if (validateStepCompletion(currentStep)) {
            if (!completedSteps.includes(currentStep)) {
                setCompletedSteps([...completedSteps, currentStep]);
            }
            setCurrentStep(step);
        } else {
            toast.warning('Please complete the current section before proceeding.');
        }

    };

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        const newFiles = files.map(file => ({
            ...VideoInitialDetails,
            video_url: file.name,
            video_member: [],
            video_event: null,
            video_subject: '',
            mal_video_subject:''
        }));
        setUploadedFiles([...uploadedFiles, ...files]);
        setVideoDetailsArray([...videoDetailsArray, ...newFiles]);
    };

    const handleRemoveFile = (index) => {
        const newFiles = uploadedFiles.filter((_, i) => i !== index);
        const newVideoDetails = videoDetailsArray.filter((_, i) => i !== index);
        setUploadedFiles(newFiles);
        setVideoDetailsArray(newVideoDetails);
    };

    const handleInputChange = (index, field, value) => {
        const updatedVideos = [...videoDetailsArray];
        updatedVideos[index][field] = value;
        setVideoDetailsArray(updatedVideos);
    };

    const handleSave = () => {

        const isFormFilled = videoDetailsArray.every(video => {
            if (video.multipart) {
                return true; // If multipart, automatically consider the form as filled
            } else {
                // Check for other fields if multipart is false
                
                return (
                    video.video_upload_date &&
                    video.kla &&
                    video.video_session &&
                    // video.numberOfVideos !== "" &&
                    video.video_url &&
                    video.video_member?.length > 0 &&
                    // video.video_event&&
                    video.mal_video_subject&&
                    video.video_subject
                );
            }
        });
        


        if (isFormFilled) {
            // Convert selected options to their values for saving
            // const dataToSave = videoDetailsArray.map(video => ({
            //     ...video,
            //     kla: video.kla.value,
            //     video_session: video.video_session.value,
            //     video_event: video.video_event.value,
            //     video_member: video.video_member.map(member => member.value),
            //     video_subject:video.video_subject,
            //     video_url:video.video_url

            // }));
            const dataToSave = videoDetailsArray?.map(video => ({
                kla:video?.kla?.value,
                video_subject:video?video?.video_subject:'',
                mal_video_subject:video?video?.mal_video_subject:'',
                video_url:video?video?.video_url:'',
                video_upload_date:video?video?.video_upload_date:'',
                video_session:video?video?.video_session?.value:'',
                // video_event:video?video?.video_event?.value:'',
                video_event:fixedEvent?.id,
                video_member:video?video?.video_member?.map(member => member?.value):'',
                multipart:video?video?.multipart:'',
                domain_name: video ? video?.domain_name?.label : '',
                file_path: video ? video?.file_path : ''
             }));
             localStorage.setItem("filePath",VideoInitialDetails?.file_path)

            const result = [];

            let currentMultipartFiles = [];
            
            dataToSave?.forEach(form => {
                if (form.multipart) {
                    currentMultipartFiles.push(form);
                } else {
                    if (currentMultipartFiles.length > 0) {
                        const commonDetails = { ...currentMultipartFiles[0] };
                        commonDetails.video_url = currentMultipartFiles.map(file => file.video_url);
                        result.push(commonDetails);
                        currentMultipartFiles = [];
                    }
                    result.push(form);
                }
            });
            
            // Check if there are any consecutive multipart forms left
            if (currentMultipartFiles.length > 0) {
                const commonDetails = { ...currentMultipartFiles[0] };
                commonDetails.video_url = currentMultipartFiles.map(file => file.video_url);
                result.push(commonDetails);
            }
            
            console.log(JSON.stringify(result, null, 2));
            // console.log(JSON.stringify(videoDetailsArray,null,2));
            // console.log(dataToSave);
            // alert('Videos added successfully');
            AddVideo({videos:result})
            handleNextStep(4)
            // setstepFourCompleted(true)
        } else {
            // const result = [];

            // let currentMultipartFiles = [];
            
            // videoDetailsArray.forEach(form => {
            //     if (form.multipart) {
            //         currentMultipartFiles.push(form);
            //     } else {
            //         if (currentMultipartFiles.length > 0) {
            //             const commonDetails = { ...currentMultipartFiles[0] };
            //             commonDetails.video_url = currentMultipartFiles.map(file => file.video_url);
            //             result.push(commonDetails);
            //             currentMultipartFiles = [];
            //         }
            //         result.push(form);
            //     }
            // });
            
            // // Check if there are any consecutive multipart forms left
            // if (currentMultipartFiles.length > 0) {
            //     const commonDetails = { ...currentMultipartFiles[0] };
            //     commonDetails.video_url = currentMultipartFiles.map(file => file.video_url);
            //     result.push(commonDetails);
            // }
            
            // console.log(JSON.stringify(result, null, 2));
            toast.warning('Please fill all the fields in the forms.');
        }


    };
    const [rows, setRows] = useState([
        // { id: '10', seq: '20', url: 'lcnvnrtbrjbjrbjfvbjlvnrkbk', status: true },
        // { id: '10', seq: '20', url: 'lcnvnrtbrjbjrbjfvbjlvnrkbk', status: true },
        // { id: '10', seq: '20', url: 'lcnvnrtbrjbjrbjfvbjlvnrkbk', status: false },
        // { id: '10', seq: '20', url: 'lcnvnrtbrjbjrbjfvbjlvnrkbk', status: true },
        // { id: '10', seq: '20', url: 'lcnvnrtbrjbjrbjfvbjlvnrkbk', status: false },
        // { id: '10', seq: '20', url: 'lcnvnrtbrjbjrbjfvbjlvnrkbk', status: true },
        // { id: '10', seq: '20', url: 'lcnvnrtbrjbjrbjfvbjlvnrkbk', status: false },
        // { id: '10', seq: '20', url: 'lcnvnrtbrjbjrbjfvbjlvnrkbk', status: true }
    ])


    const AddVideo = async (dataToSave) => {
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        // console.log(videoDetailsArray);
        // const reqBody=[{
        //     // video_sequence_no:70,
        //     // video_title: "Legislation",
        //     video_subject: videoDetailsArray?.video_subject,
        //     video_upload_date: videoDetailsArray?.video_upload_date,
        //     video_url: videoDetailsArray?.video_url,
        //     // "video_tags": [1],
        //     video_event:videoDetailsArray?.video_event,
        //     // "part_order": 3,
        //     video_session:videoDetailsArray?.video_session,
        //     video_member: videoDetailsArray?.video_member,
        //     // "parent_video":44,
        //     kla: videoDetailsArray?.kla

        // }
        // ]
        // console.log(reqBody);
        const res = await AddRulingsApi(dataToSave, reqHeader);
        console.log(res);
        setRows(res?.data?.data)
        setErrorMsg(res?.response?.data?.message)
    }
    const isStepCompleted = (step) => completedSteps.includes(step);

    const stepperStyle = (step) => ({
        backgroundColor: currentStep === step || isStepCompleted(step) ? '#009f6b' : '#dcdcdc',
        color: currentStep === step || isStepCompleted(step) ? '#fff' : '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '3rem',
        height: '3rem',
        borderRadius: '50%',
        margin: '1rem 0',
        fontSize: '1.2rem',
        cursor: 'pointer',
    });

   
    const handleFinishAdd = () => {
        // const isFormFilled = videoDetailsArray.every(video => (
        //     video.video_url && video.video_subject && video.video_event && video.video_member?.length > 0
        // ));

        // if (isFormFilled) {
        //     setAddVideo(false)
        // }
        // else {
        //     toast.warning("You are missing somehting to complete")
        // }
        toast.success("Rulings added ")
        setaddrulings(false)
    }

    // get kla list
    const klaListCallApi = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            // console.log(result);
            setKlaList(result?.data?.data)
            // console.log(klaList);
            // console.log(result?.data?.results);
            // setGetBsListData(result?.data?.results)

        } catch (error) {
            console.error("Error fetching Kla list for filter:", error);
        }
    }

    useEffect(() => {
        klaListCallApi();
    }, []);

    // kla dropdown




    // Define klaoptions outside useEffect
    const [klaoptions, setKlaOptions] = useState([]);


    useEffect(() => {
        if (klaList?.length > 0) {
            const options = klaList.map(item => ({
                value: item.kla_id,
                label: `KLA${item.kla_no}`,
                valueApi: item.kla_id,
                valueToMax: item.kla_no

            }));
            setKlaOptions(options);

            //    const latestKLA = options.reduce((maxKLA, currentKLA) => {
            //     return currentKLA.valueToMax > maxKLA.valueToMax ? currentKLA : maxKLA;
            // }, options[0]); 
            const latestKLA = options.reduce((maxKLA, currentKLA) => {
                return currentKLA.valueToMax > maxKLA.valueToMax ? currentKLA : maxKLA;
            }, options[0]); // Initialize with the first KLA option
            setVideoInitialDetails(prevState => ({
                ...prevState,
                kla: latestKLA
            }));
        }
    }, [klaList]);




    // useEffect(()=>{
    //     if (latestKLA) {
    //         VideoInitialDetails.kla = latestKLA;
    //         console.log(latestKLA); // Accessing the value property
    //         // console.log(latestKLA); // Accessing the label property
    //     } else {
    //         console.log("latestKLA is undefined or null");
    //     }
    // },[])


    // useEffect(()=>{
    //     console.log(VideoInitialDetails);
    // },[videoDetailsArray])

    const [sessionoptions, setSessionOptions] = useState([]);

    //get session list
       // API call to get the session list
  const SessionListCallApi = async () => {
    try {
      let resultSession;
      if (VideoInitialDetails.kla) {
        const kla = VideoInitialDetails.kla.valueApi;
        resultSession = await GetSessionListForSearchFilterWithKla(kla);
        setSessionList(resultSession?.data?.data ?? []);
        console.log('Session list fetched for kla:', kla);
      } else {
        resultSession = await GetSessionListForSearchFilter();
        setSessionList(resultSession?.data?.data ?? []);
        console.log('Session list fetched without specific kla');
      }
    } catch (error) {
      console.error('Error fetching session list for filter:', error);
    }
  };

  // Trigger the API call whenever kla changes
  useEffect(() => {
    SessionListCallApi();
  }, [VideoInitialDetails.kla]);

  // Update session options and the video session in VideoInitialDetails
  useEffect(() => {
    if (sessionList.length > 0) {
      const options = sessionList.map((item) => ({
        value: item.session_id,
        label: `Session ${item.session_no}`,
        valueApi: item.session_id,
      }));
      setSessionOptions(options);

      // Set the latest session as the default if available
      const latestSession = options.reduce((maxSN, currentSN) => {
        return currentSN.value > maxSN.value ? currentSN : maxSN;
      }, options[0]);

      setVideoInitialDetails((prevState) => ({
        ...prevState,
        video_session: latestSession,
      }));
    } else {
      // Reset session options and video session if no sessions are available
      setSessionOptions([]);
      setVideoInitialDetails((prevState) => ({
        ...prevState,
        video_session: null,
      }));
    } 
  }, [sessionList]);

    // get event    const [memberList, setMemberList] = useState([])

    const EventListCallApi = async () => {
        try {
            const resultEvent = await GetEventListForSearchFilter();
            // console.log(resultEvent);
            setEventList(resultEvent?.data?.data)
        } catch (error) {
            console.error("Error fetching Event list for folter:", error);
        }
    }
    useEffect(()=>{
        if (eventList) {
            eventList?.forEach((it) => {
                // Normalize event_name by removing spaces, converting to lowercase, and removing symbols
                const normalizedEventName = it?.event_name?.toLowerCase().replace(/[^a-z0-9]/g, '');
                // console.log(normalizedEventName);
                
                if (normalizedEventName == "rulingsfromthechair") {
                    setFixedEvent(prevState => ({
                        ...prevState, // Spread the previous state
                        label:it?.event_name,
                        id: it?.event_id // Update the id key
                    }));
                    // Perform your action here when the condition is met
                    console.log("Governors Address Event found");
                }
            });
        }
    },[eventList])

    useEffect(() => {
        EventListCallApi();
    }, []);

    // event dropdown
    const eventoptions = eventList?.map((item, index) => ({
        value: item.event_id,
        label: `${item.event_name}`,
        valuefrosearch: item.event_id
    }));

    useEffect(() => {
        console.log(VideoInitialDetails.video_upload_date);
    }, [VideoInitialDetails.video_upload_date, handleNextStep])


    // get Member list
    const MemberListCallApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            if(VideoInitialDetails?.video_session?.value){
                const resultMember = await getCurrentSpeaker({session_id:VideoInitialDetails?.video_session?.value});
                console.log(resultMember);
                setMemberList(resultMember?.data)
            }
           
        } catch (error) {
            console.error("Error fetching Member list for filter:", error); 
        }
    }


    useEffect(() => {
        MemberListCallApi();
    }, [VideoInitialDetails.video_session]);

    // member dropdown
    const memberoptions = memberList?.map((item, index) => ({
        value: item.mapping_ids[0],
        label: `${item?.member}`,
        valuefrosearch: item.mapping_ids[0]
    }));
    const [specificDates,setSpecificDates]=useState([])

    const GetSittingsDate=async()=>{
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const session = VideoInitialDetails?.video_session?.valueApi
        const res= await getSittingDates({session_id:session},reqHeader)
        console.log(res);
        const FormattedDates = res?.data?.data?.map(date => new Date(...date));
        console.log(FormattedDates);
        console.log(res?.data?.dat);
        
        
        setSpecificDates(FormattedDates)
        
    }
    useEffect(()=>{
        GetSittingsDate()
    },[VideoInitialDetails?.video_session])

    const rulingsAddScript=()=>{
        for(var i=0;i<=50;i++){
        addN()
        }
    }
    const addN=async()=>{
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const newdetails={"videos":[{"kla":23,"video_subject":"sub1","mal_video_subject":"subm1","video_url":"050224-Budget-Speech-1a-KNBalagopal.mp4","video_upload_date":"2024-02-05","video_session":106,"video_event":17,"video_member":[199]}]}
        const res = await AddRulingsApi(newdetails, reqHeader);
    } 
    
    return (
        <>
            <div className='flex w-full h-full flex-row' style={{ height: '86vh' }}>
                {/* <button onClick={rulingsAddScript}>activate script</button> */}
                <div className='ms-2 mb-10 me-2 flex flex-col w-1/12 justify-start items-center bg-success rounded' style={{ height: '86vh' }}>
                    {[1, 2, 3, 4].map(step => (
                        <div key={step} className='flex flex-col items-center'>
                            <div className='transform duration-1000 ease-in'
                                style={stepperStyle(step)}
                            // onClick={() => handleNextStep(step)}
                            >
                                {isStepCompleted(step) ? (
                                    <Icon icon="ci:circle-check" className='text-2xl ' />
                                ) : (
                                    <span>{step}</span>
                                )}
                            </div>
                            {step < 4 && <div className={`w-1 h-24 transform duration-1000 rounded-full ease-in `} style={{ backgroundColor: `${currentStep >= step ? '#009f6b' : '#dcdcdc'}` }}></div>}
                        </div>
                    ))}
                </div>

                {currentStep === 1 && (
                    <div className='w-full flex items-center flex-col'>
                        <h3 className='text-blue-700 text-xl font-bold mt-20 mb-4 text-center'>Enter Common Value</h3>
                        <div className='flex flex-row justify-center flex-wrap mb-10 ms-5 me-5 gap-5 w-full'>

                            <div className='flex flex-col w-2/12 mb-5 mt-5'>
                                <label htmlFor="kla">KLA</label>
                                <Select
                                    id='kla'
                                    options={klaoptions}
                                    value={VideoInitialDetails.kla}
                                    onChange={option => setVideoInitialDetails({ ...VideoInitialDetails, kla: option })}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                            height: '2rem',
                                            borderRadius: '0.3rem',
                                        }),
                                    }}
                                />
                            </div>

                            <div className='w-2/12 flex flex-col  mb-5 mt-5'>
                                <label htmlFor="session">Session</label>
                                <Select
                                    id='session'
                                    options={sessionoptions}
                                    value={VideoInitialDetails.video_session}
                                    onChange={option => setVideoInitialDetails({ ...VideoInitialDetails, video_session: option })}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                            height: '2rem',
                                            borderRadius: '0.3rem',
                                        }),
                                    }}
                                />
                            </div>

                            <div className='w-2/12 flex flex-col mb-5 mt-5'>
                                <label htmlFor="date">Date</label>
                                {/* <div className=' rounded w-10/12' > */}
                                <DatePicker
                                showIcon
                                // showYearPicker
                                    includeDates={specificDates??specificDates}
                                    showYearDropdown
                                    showMonthDropdown
                                    placeholderText="Click here to select Date"
                                    selected={parseDate(VideoInitialDetails.video_upload_date)}
                                    onChange={handleDateChange}
                                    dateFormat="dd/MM/yyyy"
                                    className='w-full h-9 rounded border border-gray-700 px-2' // Adjusted class
                                    highlightDates={specificDates??specificDates}
                                    // isClearable
                                >
                                 <div className='' style={{ color: "red" }}>Only shows sitting dates! <button onClick={()=>navigate('/octobersky/session')} className='ms-2 bg-blue-500 rounded text-white px-1'>Add sitting</button></div>
                                 </DatePicker>
                                {/* </div> */}
                            </div>

                            <div className='flex flex-col w-2/12 mb-5 mt-5'>
                            <label className='flex flex-row gap-1 items-center' htmlFor="dn">Domain Name<InfoIcon content="Domain determines where the video is to be stored"/> </label> 
                            <Select
                                    id='dn'
                                    options={domainOptions}
                                    value={VideoInitialDetails.domain_name}
                                    onChange={option => setVideoInitialDetails({ ...VideoInitialDetails, domain_name: option })}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                            height: '2rem',
                                            borderRadius: '0.3rem',
                                        }),
                                    }}
                                />
                            </div>


                            <div className='flex flex-col w-2/12 mb-5 mt-5'>
                            <label className='flex flex-row gap-1 items-center' htmlFor="fp">Video storage file path<InfoIcon content="File path determines the location on the device where the video is to be stored eg: video/kla_09112024"/> </label> 
                                <input
                                    id='fp'
                                    value={VideoInitialDetails.file_path}
                                    onChange={e => setVideoInitialDetails({ ...VideoInitialDetails, file_path: e.target.value })}
                                    type='text'
                                    placeholder='Enter file path'
                                    className='w-full h-9 rounded border border-gray-700 px-2' 
                                />
                            </div>

                        </div>
                        <br />
                        <div className='flex flex-row justify-end mt-5'>
  <div className='font-bold uppercase'>
    {/* <span className='text-blue-700 me-1 text-lg'>Note:</span> */}
    <span className='border py-3 px-4 border-yellow-500 text-yellow-900 bg-yellow-100 rounded-lg shadow-lg'>
      <span className='font-extrabold text-red-600'>Important: </span> 
      To proceed, ensure the required video file is manually transferred (scp, sftp,rsync, etc) to the specified folder path on the server.
    </span>
  </div>
  {/* <button ><span className='hover:bg-red-500 px-2 rounded-e py-1 text-red-500 hover:text-white border-yellow-500 border'>X</span></button> */}
</div>

                        <br />
                        <div className='w-2/12'>
                            <button onClick={() => handleNextStep(2)} className='w-full py-2 bg-primary text-white rounded-full'>Next</button>
                        </div>
                    </div>
                )}

                {currentStep === 2 && (
                    <div className='w-full flex items-center flex-col overflow-y-scroll overflow-x-hidden' style={{ height: '87vh' }}>
                        <div className='flex flex-row justify-center flex-wrap mt-10 mb-10 w-full '>
                            <div className=' flex flex-col justify-center items-center'>
                                <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Upload Videos</h3>
                                <div className='w-5/12 h-96 px-10 border-4 border-dashed border-blue-400 bg-success justify-center items-center flex flex-col'>
                                    <label htmlFor="fileUpload" className='mb-10 flex flex-col justify-center items-center'>
                                        <img className='w-full h-full' src="https://static.vecteezy.com/system/resources/previews/015/110/826/original/3d-illustration-of-upload-video-on-cloud-png.png" alt="" />
                                        <span className='text-blue-500'>Click here to upload</span>
                                    </label>

                                    <div className='flex flex-row'>
                                        <input
                                            id='fileUpload'
                                            type="file"
                                            className='hidden'
                                            onChange={handleFileUpload}
                                            multiple
                                        />
                                    </div>
                                </div>
                                <div className={`mt-4 p-2 rounded ${uploadedFiles.length > 0 && 'overflow-x-scroll bg-success w-full border'}`}>
                                    {uploadedFiles.length > 0 && (
                                        <>
                                            <h2 className='text-md text-blue-500 mb-2'>{uploadedFiles.length} Files Uploaded</h2>
                                            <ul>
                                                {uploadedFiles.map((file, index) => (
                                                    <li key={index} className='flex justify-between items-center border rounded bg-gray-100 hover:shadow-lg hover:bg-gray-400 px-2 m-1'>
                                                        <span className='text-gray-700 mt-1 '>{file.name}</span>
                                                        <button onClick={() => handleRemoveFile(index)} className='ml-4 text-red-500'><Icon icon="mdi:remove" className='text-lg' /></button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='w-2/12'>
                            <button onClick={() => handleNextStep(3)} className='w-full py-2 bg-primary text-white rounded-full'>Next</button>
                        </div>
                    </div>
                )}

                {currentStep === 3 && (
                    <div className='w-full flex items-center flex-col overflow-y-scroll overflow-x-hidden' style={{ height: '87vh' }}>
                        <div className='flex flex-row justify-center flex-wrap ms-5 me-5 gap-1 w-full '>
                            <div className='w-full flex justify-between items-center border pt-5 px-5 pb-5 rounded bg-success'>
                                <h3 className='text-blue-700 text-xl font-bold text-center'>Prsetted Values</h3>
                                <div className='flex flex-col w-1/4'>
                                    {/* <label htmlFor="kla">KLA</label> */}
                                    <input
                                        id="kla"
                                        value={VideoInitialDetails.kla?.label || ''}
                                        type="text"
                                        className='bg-transparent border border-dashed border-blue-500 w-full h-10 rounded-lg'
                                        // style={{ border: '1px solid #384D6C' }}
                                        readOnly
                                    />
                                </div>

                                <div className='w-2/12 flex flex-col'>
                                    {/* <label htmlFor="session">Session</label> */}
                                    <input
                                        id="session"
                                        value={VideoInitialDetails.video_session?.label || ''}
                                        type="text"
                                        className='bg-transparent border border-dashed border-blue-500 w-full h-10 rounded-lg'
                                        // style={{ border: '1px solid #384D6C' }}
                                        readOnly
                                    />
                                </div>

                                <div className='w-2/12 flex flex-col'>
                                    {/* <label htmlFor="session">Session</label> */}
                                    <input
                                        id="session"
                                        value={fixedEvent?.label || ''}
                                        type="text"
                                        className='bg-transparent border border-dashed border-blue-500 w-full h-10 rounded-lg'
                                        // style={{ border: '1px solid #384D6C' }}
                                        readOnly
                                    />
                                </div>

                                <div className='w-2/12 flex flex-col'>
                                    {/* <label htmlFor="date">Date</label> */}
                                    <input
                                        id="date"
                                        value={VideoInitialDetails.video_upload_date}
                                        type="text"
                                        className='bg-transparent border border-dashed border-blue-500 w-full h-10 rounded-lg'
                                        // style={{ border: '1px solid #384D6C' }}
                                        readOnly
                                    />
                                </div>
                            </div>

                            {videoDetailsArray.map((video, index) => (
                                <div key={index} className='flex flex-col w-full ' draggable
                                    onDragStart={(event) => handleDragStart(event, index)}
                                    onDragOver={(event) => handleDragOver(event, index)}
                                    onDrop={(event) => handleDrop(event, index)}
                                    style={{ cursor: 'move' }}>
                                    <div className={`${video?.multipart ? 'bg-gray-400 w-11/12' : 'bg-gray-100 w-full'} px-4 pb-2 pt-0.5 rounded border`}>
                                        <h3 className='text-blue-700 mb-1 text-sm'>Enter Video {index + 1} Details</h3>

                                        <div className='flex flex-row justify-between flex-wrap mb-2'>
                                            <div className='flex flex-col md:w-2/12 w-full'>
                                                <label htmlFor={`filename_${index}`}>File Name</label>
                                                <input
                                                    id={`filename_${index}`}
                                                    value={video.video_url}
                                                    type="text"
                                                    className='dateinput w-full h-10 rounded-lg'
                                                    style={{ border: '1px solid #384D6C' }}
                                                    readOnly
                                                />
                                            </div>

                                            <div className='flex flex-col md:w-2/12 w-full'>
                                                <label htmlFor={`subject_${index}`}>Subject<span className='text-red-500'>*</span></label>
                                                <input
                                                    id={`subject_${index}`}
                                                    value={video.video_subject}
                                                    onChange={(e) => handleInputChange(index, 'video_subject', e.target.value)}
                                                    type="text"
                                                    className='dateinput w-full h-10 rounded-lg'
                                                    style={{ border: '1px solid #384D6C' }}
                                                />
                                            </div>

                                            {/* <div className='flex flex-col md:w-2/12 w-full'>
                                                <label htmlFor={`mal_subject_${index}`}>Subject malayalam<span className='text-red-500'>*</span></label>
                                                <input
                                                    id={`mal_subject_${index}`}
                                                    value={video.mal_video_subject}
                                                    onChange={(e) => handleInputChange(index, 'mal_video_subject', e.target.value)}
                                                    type="text"
                                                    className='dateinput w-full h-10 rounded-lg'
                                                    style={{ border: '1px solid #384D6C' }}
                                                />
                                            </div> */}

                                            <div className=' flex flex-col min-w-52 '>
                                                <label htmlFor={`member_${index}`}>Members<span className='text-red-500'>*</span></label>
                                                <Select
                                                    id={`member_${index}`}
                                                    options={memberoptions}
                                                    value={video.video_member}
                                                    onChange={option => handleInputChange(index, 'video_member', option)}
                                                    isMulti
                                                    styles={{
                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                            height: '2rem',
                                                            borderRadius: '0.5rem',
                                                        }),
                                                    }}
                                                    // styles={customStyles}
                                                    // components={{ Option: CustomOption }}
                                                />
                                            </div>
                                            {/* <div className=' flex flex-col md:w-2/12 w-full'>
                                                <label htmlFor={`event_${index}`}>Event<span className='text-red-500'>*</span></label>
                                                <Select
                                                    isClearable
                                                    id={`event_${index}`}
                                                    options={eventoptions}
                                                    value={video.video_event}
                                                    onChange={option => handleInputChange(index, 'video_event', option)}
                                                    styles={{
                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                            height: '2rem',
                                                            borderRadius: '0.5rem',
                                                        }),
                                                    }}
                                                />
                                            </div> */}

                                            <div className=' flex flex-col justify-center'>
                                                <label htmlFor={`multipart${index}`}>Multipart</label>
                                                <input
                                                    id={`multipart${index}`}
                                                    value={video.multipart}
                                                    onChange={(e) => handleInputChange(index, 'multipart', e.target.checked)}
                                                    className='h-6' onClick={() => console.log(video)} type="checkbox" />
                                            </div>
                                        </div>

                                        {/* <div className='flex flex-row justify-between flex-wrap'>
                                            
                                        </div> */}
                                    </div>
                                </div>
                            ))}

                        </div>
                        <br />
                        <div className='w-2/12 mb-20'>
                            <button onClick={handleSave} className='w-full py-2 rounded-full bg-primary text-white mb-10'>Save as draft and proceed</button>
                        </div>
                    </div>
                )}

                {currentStep === 4 && (
                    <div className='w-full flex items-center flex-col' >
                        <div className='flex flex-col justify-center items-center flex-wrap w-full'>
                            <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Uploaded status</h3>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }} >Sl no</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }} align="left">Id</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }} align="left">Seq no</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }} align="left">Url</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }} align="left">Status</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {rows?.length>0?rows?.map((row, index) => (
                                            <TableRow
                                                style={{ backgroundColor: `${index % 2 == 0 ? '#F3F4F6' : '#F9FAFB'}` }}
                                                key={row.name}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell style={{ fontFamily: 'ropa sans' }} component="th" scope="row">
                                                    {index + 1}
                                                </TableCell>
                                                <TableCell style={{ fontFamily: 'ropa sans' }} align="left">{row.video_id}</TableCell>
                                                <TableCell style={{ fontFamily: 'ropa sans' }} align="left">{row.video_sequence_no}</TableCell>
                                                <TableCell style={{ fontFamily: 'ropa sans' }} align="left">{row.video_url}</TableCell>
                                                <TableCell style={{ color: `${row.status ? '#16A34A' : '#DC2626'}`, fontFamily: 'ropa sans', display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center' }} align="left">{row.status ? 'Success' : 'Failed'}<Icon icon={`${row.status ? 'icon-park-outline:success' : 'fluent:document-error-20-regular'}`} className='ms-1' /></TableCell>
                                            </TableRow>
                                        ))
                                        :
                                        <>
                                        {errorMsg?
                                         <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                                         <p className="text-red-500 flex flex-row items-center text-lg gap-1"><span>{errorMsg}</span><Icon icon="material-symbols:error-outline" className='text-lg' /></p>
                                         </div>
                                        :
                                        <p>Loading... Please wait</p>}
                                        </>}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <br />
                        <div className='w-2/12'>
                            <button onClick={handleFinishAdd} className='w-full py-2 bg-primary text-white rounded-full'>Finish</button>
                        </div>
                    </div>
                )}
            </div>

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default AddRulings;




